import { ShareTargetType } from '@bindoc-projects/resource-domain-lib';

export class BdFeaturesPermissionsAdminStore {
  constructor(private readonly _baseUrl: string) {}

  public base(): string {
    return this._baseUrl;
  }

  public featurePermissions(): string {
    return `${this.base()}/feature-permissions/`;
  }

  public getAllPermissions(
    shareTargetType: ShareTargetType,
    shareTargetId: string,
  ): string {
    return `${this.base()}/feature-permissions/${shareTargetType}/${shareTargetId}`;
  }
}
